const AppReducer = (state, action) => {
  switch (action.type) {
    case 'SET_TOKEN':
      return {
        ...state,
        authToken: action.payload,
      };
    case 'SET_PERMISSION_LEVEL':
      return {
        ...state,
        permissionLevel: action.payload,
      };
    case 'SET_SKILL':
      return {
        ...state,
        skill: action.payload,
      };
    case 'SET_CAMPAIGN':
      return {
        ...state,
        campaign: action.payload,
      };
    case 'SET_ENVIRONMENT':
      return {
        ...state,
        environment: action.payload,
      };

    default:
      return state;
  }
};

export default AppReducer;
